import React from 'react';
import { PurpleCircleSvg } from 'apps/sigma2-ui/src/components/svg/PurpleCircle';
import { OrganizationSecretItems } from 'libs/end-to-end/src/types/secrets/organization-secret-items';
import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { useDataSetSecretSelector } from 'apps/sigma2-ui/src/data-wizard/lib/useDataSetSecretSelector';
import { Button } from 'apps/sigma2-ui/src/components/ui/Button';
import cn from 'classnames';
import { Paragraph } from 'apps/sigma2-ui/src/components/ui/Paragraph';
import { Spacing } from 'apps/sigma2-ui/src/components/ui/Spacing';
import { ReadPatternHook } from 'apps/sigma2-ui/src/lib/hooks/useReadPattern';

export const DataSetSecretSelector = ({
  secretReference,
  setSecretReference,
  organizationId,
  label,
  listSecretsPattern,
}: {
  label: string;
  secretReference: SecretReference | null;
  setSecretReference: (secretReference: SecretReference | null) => void;
  organizationId: string;
  listSecretsPattern: ReadPatternHook<OrganizationSecretItems>;
}) => {
  const {
    setStatus,
    modal,
    buttonBehavior,
    buttonLabel,
    currentSecretDescription,
    clearButtonBehavior,
    clearButtonLabel,
    clearButtonDisabled,
  } = useDataSetSecretSelector({
    secretReference,
    setSecretReference,
    organizationId,
    listSecretsPattern,
  });

  return (
    <>
      <Spacing size={'md'} direction={'horizontal'}>
        <Paragraph>{label}</Paragraph>
        <Button behavior={buttonBehavior} text={buttonLabel} />
        <PurpleCircleSvg
          svg={{
            className: cn(
              'w-4 h-4',
              setStatus === 'set'
                ? 'text-green-300'
                : setStatus === 'not-set'
                  ? 'text-red-400'
                  : 'text-orange-300',
            ),
          }}
          wantsCurrentColor
        />
        {currentSecretDescription}
        <Button
          behavior={clearButtonBehavior}
          text={clearButtonLabel}
          disabled={clearButtonDisabled}
        />
      </Spacing>
      {modal}
    </>
  );
};
